export default __webpack_public_path__ + "652996944a2235d66366635b6146a8cc.png";